module.exports = __webpack_public_path__ + "img/logo.71c73e0e.png";